import {ImageModel, ListModel} from "../common";

export enum SubaccountPlanModel {
  FREE = "free",
  PAID = "paid",
}

export interface SubaccountRecordModel {
  id: string;
  name: string;
  lastActive: string;
  agents: number;
  minutesUsed: number;
  minutesLimit: number;
  users: number;
  plan: SubaccountPlanModel;
  avatar?: ImageModel;
}

export type SubaccountRecordListModel = ListModel<SubaccountRecordModel>;
